import { AnalyticsEvent } from '../../analytics.event';

export class NavigationEvent extends AnalyticsEvent {
    constructor(from: string, to: string) {
        super('page_view', {
            from,
            to
        });
    }
}
